import { useEffect, useState } from 'react';
import axios from 'axios';

import styles from './Events.module.css';

import CardEvents from '../../components/CardEvents';
import Title from '../../components/Title';

export default function Events() {
  const [eventsData, setEventsData] = useState([]);

  useEffect(() => {
    axios.get('https://back-cultura-sje-production.up.railway.app/eventos', {})
      .then((response) => {
        setEventsData(response.data)})
      .catch((error) => {
        console.error('Erro ao buscar eventos', error);
      })
  }, []);

  return (
    <main className={styles.page}>
      <div className={styles.container}>
        <div className={styles.containerHeader}>
          <Title>Todos os Eventos</Title>
        </div>
        <div className={styles.grid}>
          {[...eventsData]
            .sort((a, b) => new Date(b.data) - new Date(a.data))
            .map((evento, i) => (
              <CardEvents key={i} evento={evento} />
            ))}
        </div>
      </div>
    </main>
  );
}

